import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gom-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
